import { z } from 'zod';

export const uuidSchema = z.string().uuid();
export const slugSchema = z
  .string()
  .min(2)
  .max(64)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'slug must be lowercase kebab-case');

export const emailSchema = z.string().email().toLowerCase().max(320);
export const isoDateSchema = z.string().datetime({ offset: true });

export const paginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type Pagination = z.infer<typeof paginationSchema>;

export const colorHexSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/);
